











import Vue from 'vue';
import { Cv, CvDesignTemplateSample } from '@/../gen';
// @ts-ignore
import CvDesignSelect from '@/components/CvDesignSelect.vue';

export interface FormDataInterface {
  cv_design_template_id: number;
}

export default Vue.extend({
  components: {
    CvDesignSelect,
  },
  props: {
    cv: {
      type: Object as () => Cv,
      required: true,
    },
    cvDesignTemplateSamples: {
      type: Array as () => CvDesignTemplateSample[],
      required: true,
    },
  },
  data() {
    return {
      formData: {
        cv_design_template_id: this.cv.cv_design_template_id,
      } as FormDataInterface,
    };
  },
  watch: {
    'formData.cv_design_template_id'() {
      this.$emit('submit', this.formData);
    },
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.formData);
    },
  },
});
